module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6n8r7r-89c8c5670991051830f203f1d9862d05.svg";